// extracted by mini-css-extract-plugin
module.exports = {"Form":"Checkout_Form__22lUA","Button":"Checkout_Button__3f3nk"};